export const GLOBAL = 'global';
export const VOLUNTEERS_SERVICE = 'volunteersService';
